import LOGO from "../images/Pistons.png";

export const Team__Pistons = {
  name: "Pistons",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#C1121F",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  // ownGoalsInFavor: 40 + 45 + 48,
  // goalsScoredAgainst: 18 + 46 + 36,
  ownGoalsInFavor: 40 + 45,
  goalsScoredAgainst: 18 + 46,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
